<footer class="footer-container" [class.has-ai]="showAI || canSwitchAccounts">
  <div id="tour-home" class="nav-slot">
    <a routerLink="/mainmenu" data-testid="nav-home" class="nav-link" [routerLinkActive]="['active-link']">
      <span class="icon-badge-wrapper">
        <i class="icon-home icon-text-blue" style="width: 24px; height: 24px;"></i>
      </span>
      <span class="caption text-text-blue" rtI18n>Home</span>
    </a>
  </div>
  <!-- Grows in proportion to how many slots it holds, so every footer item — Home, each pinned
       app, and the AI button — ends up the same width. -->
  <div class="nav-droplist"
       [style.flex-grow]="navSlotCount"
       [class.editing]="isEditMode"
       cdkDropList
       [id]="isEditMode ? 'footer-apps-drop-list' : null"
       cdkDropListOrientation="horizontal"
       [cdkDropListDisabled]="!isEditMode"
       [cdkDropListConnectedTo]="['apps-grid-drop-list']"
       [cdkDropListEnterPredicate]="canDropInHeader"
       (cdkDropListDropped)="onHeaderDrop($event)">
    @for (app of headerApps; track app.Id) {
      <div class="nav-slot" [attr.id]="tourAnchorId(app)"
           cdkDrag [cdkDragData]="app" [cdkDragDisabled]="!isEditMode">
        <a [routerLink]="navRoute(app)"
           [attr.data-testid]="'nav-' + app.ClickPath"
           class="nav-link"
           [routerLinkActive]="['active-link']">
          <span class="icon-badge-wrapper">
            @if (app.HeaderIconClass) {
              <i class="icon-text-blue" [ngClass]="app.HeaderIconClass" style="width: 24px; height: 24px;"></i>
            } @else if (app.IconPath) {
              <img [src]="app.IconPath" alt="" style="width: 24px; height: 24px; object-fit: contain;" />
            }
            @if (badgeFor(app) > 0) {
              <span class="menu-item-badge">
                {{badgeFor(app) > 9 ? '9+' : badgeFor(app)}}
              </span>
            }
          </span>
          <!-- Titles arrive translated from the server; rtI18n can't take an interpolation. -->
          <span class="caption text-text-blue">{{app.Title}}</span>
        </a>
        @if (isEditMode) {
          <button type="button" class="nav-remove-btn"
                  [attr.aria-label]="'Remove ' + app.Title + ' from the bar'"
                  [attr.data-testid]="'nav-remove-' + app.ClickPath"
                  (click)="removeFromHeader(app, $event)">
            <i class="icon-x icon-white"></i>
          </button>
        }
      </div>
    }
    @if (pinBlockReason) {
      <div class="nav-slot nav-drop-hint nav-drop-blocked">
        <i class="icon-warning icon-orange"></i>
        @if (pinBlockReason === 'bar-full') {
          <span rtI18n>The bar is full — remove an app first</span>
        } @else {
          <span rtI18n>This app can't be pinned to the bar</span>
        }
      </div>
    } @else if (isEditMode) {
      @for (slot of emptySlots; track slot) {
        <div class="nav-slot nav-drop-hint nav-empty-slot" rtI18n>Drag here</div>
      }
    }
    @if (showAddSlot) {
      <div class="nav-slot">
        <button type="button" class="nav-add-btn" data-testid="nav-add-app"
                aria-label="Add an app to the bar"
                (click)="onAddAppClick()">
          <span class="icon-badge-wrapper">
            <i class="icon-add-app icon-action-blue" style="width: 24px; height: 24px;"></i>
          </span>
          <span class="caption text-text-blue" rtI18n>Add</span>
        </button>
      </div>
    }
  </div>
  @if (showAI || canSwitchAccounts) {
    <div class="col-ai">
      @if (canSwitchAccounts) {
        <!-- With a linked account, the footer shows the user's photo (like the web switcher) and
             opens a menu: Help bot + account switch. -->
        <button type="button" id="tour-ai-widget" class="nav-link ai-footer-btn account-switch-footer-btn"
                [matMenuTriggerFor]="helpMenu" (menuOpened)="checkLinkedGuardian()"
                aria-haspopup="menu" aria-label="Account and help options">
          <span class="icon-badge-wrapper account-switch-footer-avatar">
            @if (currentUser; as profile) {
              <user-image [userId]="profile.Id" [size]="'26px'" [profileEnabled]="false"></user-image>
            }
            <span class="account-switch-footer-caret">
              <i class="icon-chevron-down icon-white"></i>
            </span>
          </span>
          <span class="caption text-text-blue" rtI18n>Account</span>
        </button>

        <mat-menu #helpMenu="matMenu" class="footer-help-menu" yPosition="above">
          @if (showAI) {
            <button type="button" mat-menu-item (click)="openAIMenu()">
              <img src="assets/images/help-desk-icon.svg" alt="" class="footer-help-menu-img" />
              <span rtI18n>Help bot</span>
            </button>
          }
          @if (showSwitchToParent) {
            <button type="button" mat-menu-item (click)="switchToParent()">
              <i class="icon-arrows-alt-h icon-action-blue footer-help-menu-icon"></i>
              <span rtI18n>Switch to Parent account</span>
            </button>
          }
          @if (isParentAccountView) {
            <button type="button" mat-menu-item (click)="switchToStaff()">
              <i class="icon-arrows-alt-h icon-action-blue footer-help-menu-icon"></i>
              <span rtI18n>Switch to Staff account</span>
            </button>
          }
        </mat-menu>
      } @else {
        <button type="button" id="tour-ai-widget" class="nav-link ai-footer-btn" (click)="openAIMenu()">
          <span class="icon-badge-wrapper">
            <img src="assets/images/help-desk-icon.svg" alt="AI Assistant" style="width: 24px; height: 24px; display: inline-block;">
          </span>
          <span class="caption text-text-blue" rtI18n>Help</span>
        </button>
      }
    </div>
  }
</footer>
